/**
 * RegisterPage
 * Kitchly v0.5.0
 */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import './AuthPages.css';

function RegisterPage() {
  const { t } = useTranslation();
  const { register } = useAuth();
  const [form, setForm] = useState({
    email: '',
    display_name: '',
    password: '',
    confirm_password: '',
    invite_code: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (form.password !== form.confirm_password) {
      setError(t('auth.passwordMismatch'));
      return;
    }

    if (form.password.length < 8) {
      setError(t('auth.passwordMinLength'));
      return;
    }

    setLoading(true);
    try {
      await register(form.email, form.password, form.display_name, form.invite_code);
    } catch (err) {
      setError(err.message || t('auth.registerError'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-logo">
        <h1>{t('app.name')}</h1>
        <p>{t('app.tagline')}</p>
      </div>

      <div className="auth-card">
        <h2>{t('auth.register')}</h2>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="invite_code">{t('auth.inviteCode')}</label>
            <input
              id="invite_code"
              name="invite_code"
              type="text"
              className="form-input"
              value={form.invite_code}
              onChange={handleChange}
              required
              placeholder="KITCHLY-ALPHA-2026"
              autoFocus
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="display_name">{t('auth.displayName')}</label>
            <input
              id="display_name"
              name="display_name"
              type="text"
              className="form-input"
              value={form.display_name}
              onChange={handleChange}
              required
              autoComplete="name"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="email">{t('auth.email')}</label>
            <input
              id="email"
              name="email"
              type="email"
              className="form-input"
              value={form.email}
              onChange={handleChange}
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="password">{t('auth.password')}</label>
            <input
              id="password"
              name="password"
              type="password"
              className="form-input"
              value={form.password}
              onChange={handleChange}
              required
              minLength={8}
              autoComplete="new-password"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="confirm_password">{t('auth.confirmPassword')}</label>
            <input
              id="confirm_password"
              name="confirm_password"
              type="password"
              className="form-input"
              value={form.confirm_password}
              onChange={handleChange}
              required
              minLength={8}
              autoComplete="new-password"
            />
          </div>

          <button type="submit" className="btn btn-primary btn-full btn-lg" disabled={loading}>
            {loading ? t('common.loading') : t('auth.register')}
          </button>
        </form>

        <div className="auth-footer">
          {t('auth.haveAccount')} <Link to="/login">{t('auth.login')}</Link>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
